import label from "@/lang/StaticLabels.js";

// PBANK Navbar  - خزانه -----------------------------------------------
let navItems = [
  {
    title: label.modules.pbank,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PBANKDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PBANKBankAccount",
        label: label.menu.bankAccountInfo,
        metaLabel: label.page.bankAccountInfo,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },

      {
        to: "PBANKCashAccount",
        label: label.menu.cashAccount,
        metaLabel: label.page.cashAccount,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBANKChecks",
        label: label.menu.checks,
        metaLabel: label.page.checks,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBANKChequeStatus",
        label: label.menu.chequeStatus,
        metaLabel: label.page.chequeStatus,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
 
      {
        to: "PBANKReceiveAndPay",
        label: label.menu.receiveAndPay,
        metaLabel: label.page.receiveAndPay,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBANKIssueTrackingType",
        label: label.menu.issueTrackingPaymentType,
        metaLabel: label.page.issueTrackingPaymentType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.paymentRequest,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKAddPaymentRequest",
            label: label.menu.addPaymentRequest,
            metaLabel: label.page.addPaymentRequest,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentRequestList",
            label: label.menu.paymentRequestList,
            metaLabel: label.page.paymentRequest,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentRequestConfirm",
            label: label.menu.paymentRequestConfirm,
            metaLabel: label.page.paymentRequestConfirm,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.receiveCash,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKAddReceiveCash",
            label: label.menu.addReceiveCash,
            metaLabel: label.page.addReceiveCash,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReceiveCashList",
            label: label.menu.receiveCashList,
            metaLabel: label.page.receiveCash,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKAddReceiveCashGroup",
            label: label.menu.addGroupReceiveCash,
            metaLabel: label.page.addGroupReceiveCash,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.paymentCash,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKAddPaymentCash",
            label: label.menu.addPaymentCash,
            metaLabel: label.page.addPaymentCash,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentCashList",
            label: label.menu.paymentCashList,
            metaLabel: label.page.paymentCash,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKAddPaymentCashGroup",
            label: label.menu.addGroupCashPayment,
            metaLabel: label.page.addPaymentCashGroup,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.interbankTransfer,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKAddInterBankTransfer",
            label: label.menu.addInterbankTransfer,
            metaLabel: label.page.addInterbankTransfer,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKInterBankTransferList",
            label: label.menu.interbankTransferList,
            metaLabel: label.page.interbankTransferList,
            icon: "mdi-circle-small",
          },
        ],
      },

      {
        to: null,
        label: label.menu.receiveCheque,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKAddReceiveCheque",
            label: label.menu.addReceiveCheque,
            metaLabel: label.page.addReceiveCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReceiveChequeList",
            label: label.menu.receiveChequeList,
            metaLabel: label.page.receiveCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKAddReceiveChequeGroup",
            label: label.menu.addReceiveChequeGroup,
            metaLabel: label.page.addReciveChequeGroup,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReceiveChequeCartable",
            label: label.menu.receiveChequeConfirm,
            metaLabel: label.page.receiveChequeConfirm,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKBankTransfer",
            label: label.menu.bankTransfer,
            metaLabel: label.page.bankTransfer,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKAssignmentPerson",
            label: label.menu.assignmentPerson,
            metaLabel: label.page.assignmentPerson,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKSettlement",
            label: label.menu.settlement,
            metaLabel: label.page.settlement,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReturnTransferred",
            label: label.menu.returnTransferred,
            metaLabel: label.page.returnTransferred,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKCancellationReceivable",
            label: label.menu.cancellationReceivable,
            metaLabel: label.page.cancellationReceivable,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReturnReceivables",
            label: label.menu.returnReceivables,
            metaLabel: label.page.returnReceivables,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReturnGuarantee",
            label: label.menu.returnGuarantee,
            metaLabel: label.page.returnGuarantee,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReturnAssignment",
            label: label.menu.returnAssignment,
            metaLabel: label.page.returnAssignment,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.paymentCheque,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKAddPaymentCheque",
            label: label.menu.addPaymentCheque,
            metaLabel: label.page.addPaymentCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentChequeList",
            label: label.menu.paymentChequeList,
            metaLabel: label.page.paymentCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKAddPaymentChequeGroup",
            label: label.menu.addPaymentChequeGroup,
            metaLabel: label.page.addPaymentChequeGroup,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKpaymentChequeCartable",
            label: label.menu.paymentChequeConfirm,
            metaLabel: label.page.paymentChequeConfirm,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPassPayDocs",
            label: label.menu.passPayDocs,
            metaLabel: label.page.passPayDocs,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKCancelPayableDocs",
            label: label.menu.cancelPayableDocs,
            metaLabel: label.page.cancelPayableDocs,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReturnGuaranteeDocs",
            label: label.menu.returnGuarantee,
            metaLabel: label.page.returnGuarantee,
            icon: "mdi-circle-small",
          },
        ],
      },
      // {
      //   to: null,
      //   label: label.menu.receiptReceived,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [
      //     {
      //       to: "PBANKAddReceiptReceived",
      //       label: label.menu.addReceiptReceived,
      //       metaLabel: label.page.addReceiptReceived,
      //       icon: "mdi-circle-small",
      //     },
      //     {
      //       to: "PBANKReceiptReceivedList",
      //       label: label.menu.listReceiptReceived,
      //       metaLabel: label.page.receiptReceived,
      //       icon: "mdi-circle-small",
      //     },
      //     {
      //       to: "PBANKReceiptReceiveCartabl",
      //       label: label.menu.addReceiptReceiveCartable,
      //       metaLabel: label.page.addReceiptReceiveCartable,
      //       icon: "mdi-circle-small",
      //     },
      //   ],
      // },
      // {
      //   to: null,
      //   label: label.menu.paymentPaper,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [
      //     {
      //       to: "PBANKAddPaymentPaper",
      //       label: label.menu.addPaymentPaper,
      //       metaLabel: label.page.addPaymentPaper,
      //       icon: "mdi-circle-small",
      //     },
      //     {
      //       to: "PBANKPaymentPaperList",
      //       label: label.menu.listPaymentPapers,
      //       metaLabel: label.page.paymentPaper,
      //       icon: "mdi-circle-small",
      //     },
      //     {
      //       to: "PBANKPaymentPapersCartable",
      //       label: label.menu.addPaymentPapersCartable,
      //       metaLabel: label.page.paymentPapersCartable,
      //       icon: "mdi-circle-small",
      //     },
      //   ],
      // },
      {
        to: null,
        label: label.menu.managementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKManagementCartablePaymentCheque",
            label: label.menu.paymentCheque,
            metaLabel: label.page.managementCartablePaymentCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKManagementCartablePaymentRequest",
            label: label.menu.paymentRequestCartable,
            metaLabel: label.page.managementCartablePaymentRequest,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKManagementCartableReceiveCheque",
            label: label.menu.receiveCheque,
            metaLabel: label.page.managementCartableReceiveCheque,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.cashReceiptAndPayment,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKReceiveAndPaymentCashReport",
            label: label.menu.receiveAndPaymentCash,
            metaLabel: label.page.receiveAndPaymentCash,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKBankAccountOperationDetailReport",
            label: label.menu.bankAccountOperationDetail,
            metaLabel: label.page.bankAccountOperationDetail,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKMonthlyReceiveAndPaymentCashReport",
            label: label.menu.monthlyReceiveAndPaymentCashReport,
            metaLabel: label.page.monthlyReceiveAndPaymentCashReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.receiveCheque,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKReceiveChequeReport",
            label: label.menu.receiveCheque,
            metaLabel: label.page.receiveCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKHistoryReceiveChequeReport",
            label: label.menu.historyReceiveChequeReport,
            metaLabel: label.page.historyReceiveChequeReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPastDueChecksReport",
            label: label.menu.pastDueChecks,
            metaLabel: label.page.checksReceivedDueed,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKMonthlyComparisonReceiveChequeReport",
            label: label.menu.monthlyComparisonReceiveCheque,
            metaLabel: label.page.monthlyComparisonReceiveCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKSummaryReceiveChequeReport",
            label: label.menu.summaryReceiveCheque,
            metaLabel: label.page.summaryReceiveCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKReceiveChequeTurnReport",
            label: label.menu.receiveChequeTurnReprot,
            metaLabel: label.page.receiveChequeTurnReprot,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.paymentCheque,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKPastDuePaymentChecksReport",
            label: label.menu.pastDueChecks,
            metaLabel: label.page.checksPaymentDueed,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKHistoryPaymentChequeReport",
            label: label.menu.historyPaymentChequeReport,
            metaLabel: label.page.historyPaymentChequeReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentChequeReport",
            label: label.menu.paymentChequeReport,
            metaLabel: label.page.paymentChequeReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKMonthlyComparisonPaymentChequeReport",
            label: label.menu.monthlyComparisonPaymentCheque,
            metaLabel: label.page.monthlyComparisonPaymentCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentChequeToPersonReport",
            label: label.menu.paymentChequeToPerson,
            metaLabel: label.page.paymentChequeToPerson,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentChequeToAccountInfoReport",
            label: label.menu.paymentChequeToAccountInfo,
            metaLabel: label.page.paymentChequeToAccountInfo,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKSummaryPaymentChequeReport",
            label: label.menu.summaryPaymentCheque,
            metaLabel: label.page.summaryPaymentCheque,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKPaymentChequeTurnReport",
            label: label.menu.paymentChequeTurn,
            metaLabel: label.page.paymentChequeTurn,
            icon: "mdi-circle-small",
          },
        ],
      },

      {
        to: null,
        label: label.menu.other,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBANKAccountInventoryReport",
            label: label.menu.accountInventoryReport,
            metaLabel: label.page.accountInventoryReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKCashFlowReport",
            label: label.menu.cashFlowReport,
            metaLabel: label.page.cashFlowReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKSummaryReport",
            label: label.menu.bankSummary,
            metaLabel: label.page.bankSummary,
            icon: "mdi-circle-small",
          },
          {
            to: "PBANKCartableLog",
            label: label.menu.cartableLog,
            metaLabel: label.page.cartableLog,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
];

export default navItems;
